import React, { Component } from 'react';
import './styles.css';
import PopUpMailLayout from '../PopUpMailLayout';
import Icon from '../Icon';
import { MessageType } from '../../types';

class PopUpMail extends Component {
	render() {
		const { from, subject, message } = this.props.message;
		return (
			<div className="pop-up-mail">
				<PopUpMailLayout>
					<PopUpMailLayout.Header>
						<Icon icon={'inbox'} />
						<span>Mail</span>
						<Icon icon={'closeMailPopUp'} />
					</PopUpMailLayout.Header>
					<PopUpMailLayout.Body>
						<span>{from}</span>
						<span>{subject}</span>
						<span>{message}</span>
					</PopUpMailLayout.Body>
				</PopUpMailLayout>
			</div>
		);
	}
}
PopUpMail.propTypes = {
	message: MessageType
};

PopUpMail.defaultProps = {
	message: {
		id: 'aaa',
		from: 'Rian Gosling - Ceo',
		subject: 'Congratulations',
		message:
      'Complimenti hai completato il businessplan, vai ai results per analizzare il tuo lavoro'
	}
};
export default PopUpMail;
